import { Page } from "@/models/page-models/Page";

export const MiscInvoicesList: Page = {
  "path": "misc-invoices",
  "name": "Miscellaneous Invoices",
  "props": {
    "data": {
      "title": "Miscellaneous Invoices",
      "printable": "FALSE",
      "url": "misc-invoices",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Miscellaneous Invoice",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToMiscInvoiceCreate",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "new-misc-invoice"
                      },
                      "name": "redirectToMiscInvoiceCreate"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Miscellaneous Invoices",
                  "disabled": "FALSE",
                  "items": "fetchedData.invoices.data.docs",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "Invoice #",
                      "type": "url",
                      "url": "misc-invoice/{{__item._id}}"
                    },
                    {
                      "value": "__item.customer.id.name",
                      "text": "Customer Name"
                    },
                    {
                      "value": "__item.total",
                      "text": "Invoice Value",
                      "formula": "fn(HELPER_FN,currency,{{__item.total}})"
                    },
                    {
                      "value": "__item.createdAt",
                      "text": " Invoice Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                    },
                    {
                      "value": "__item.status",
                      "text": "Status"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "selectableUniqueId": "_id",
                  "singleSelect": true,
                  "groupActions": [
                    {
                      "label": "Approve & Clear",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "approveMiscInvoice",
                            "type": "fnSubmit",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/misc-invoice/{{__item._id}}/approve",
                            "arg2Key": "postData",
                            "arg2Value": "{}",
                            "arg3Key": "requestMethod",
                            "arg3Value": "PATCH",
                            "arg4Key": "storeResponse",
                            "arg4Value": "TRUE"
                          },
                          "name": "approveMiscInvoice"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "showCreatedInvoiceSnackbar",
                            "type": "fnOpenSnackbar",
                            "color": "secondary",
                            "serverMessage": "Misc Invoice Approved, requesting ZATCA Clearance"
                          },
                          "name": "showCreatedInvoiceSnackbar"
                        },
                        {
                          "executionOrder": 3,
                          "pageFunction": {
                            "name": "clearInvoice",
                            "type": "fnSubmit",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/e-invoicing/clear-misc-invoice/{{__item._id}}?type=Invoice",
                            "arg2Key": "postData",
                            "arg2Value": "{}",
                            "arg3Key": "refreshPage",
                            "arg3Value": "TRUE",
                            "arg4Key": "requestMethod",
                            "arg4Value": "GET"
                          },
                          "name": "clearInvoice"
                        }
                      ],
                      "disableIf": "fn(LOGICAL,fn(CONCAT,',{{__item.0.status}},'),==,'Approved')",
                      "showIf": "fn(MATCH_ROLE,General Manager)"  
                    },
                    {
                      "label": "Clear",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "clearInvoice",
                            "type": "fnSubmit",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/e-invoicing/clear-misc-invoice/{{__item._id}}?type=Invoice",
                            "arg2Key": "postData",
                            "arg2Value": "{}",
                            "arg3Key": "refreshPage",
                            "arg3Value": "TRUE",
                            "arg4Key": "requestMethod",
                            "arg4Value": "GET"
                          },
                          "name": "clearInvoice"
                        }
                      ],
                      "disableIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{__item.0.status}},'),==,'Approved'),&&,fn(NOT,fn(NOT,{{__item.0.clearedInvoice}})))",
                      "showIf": "fn(MATCH_ROLE,General Manager)"
                    }
                  ],
                  "neverHideActionBar": true
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMiscellaneousInvoices",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/misc-invoice/all?limit=50=page=1",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.invoices"
        },
        "name": "getMachines"
      }
    ],
    "functions": []
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,GENERAL_MANAGER",
  "visible": true
}